import css from 'styled-jsx/css';

const styles = css`.loading{display:flex;justify-content:center;background-size:cover;background-position:center}.loading.top{padding-top:3rem}.loading.center{height:100%;align-items:center}`;

export default styles;